module.exports = __webpack_public_path__ + "img/15.1df39747.gif";